var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"con-s"},[_c('vs-td',{staticClass:"whitespace-no-wrap"},[_c('vs-switch',{attrs:{"color":"success"},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }